import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { uploadBytes, getStorage, ref, getDownloadURL, getBlob, listAll } from "firebase/storage";
import { storage } from "../../utilities/firebase";
import axios from "axios";
import moment from "moment";
import AddDocuments from "./additional-details";
import BlacklistEdit from "../admin/features/blacklist/blacklist";
import RepEdit from "../admin/features/reps/representatives";
import DetailRepEdit from "../admin/features/reps/details";
import DetailEdit from "../admin/features/blacklist/details";
import Cookies from "js-cookie";
import CompanyDetails from "../../blacklist-form/company-details";
import AdditionalDocs from "../../blacklist-form/additional-docs";
import { CircleLoader } from "react-spinners";

const Details = () => {
    

    const [showDocs, setShowDocs] = useState(false);
    const [IDdownload, setIDdownload] = useState('ID document');
    const [Companydownload, setCompanyRegdownload] = useState('company registration');
    const [Addressdownload, setAddressdownload] = useState('proof of address');
    const [Contractdownload, setContractdownload] = useState('contract/agreement');

    const [editMode, setEditMode] = useState(false);
    const [repEditMode, setRepEditMode] = useState(false);
    const [blacklistEditMode, setBlacklistEditMode] = useState(false)
    const [done, setDone] = useState(false)

    const [showCompany, setShowCompany] = useState(false);
    const [showRep, setShowRep] = useState(false);

    const [companyDocuments, setCompanyDocuments] = useState([])
    const [additionalDocuments, setAdditionalDocuments] = useState([])
    const [incidentDocuments, setIncidentDocuments] = useState([])
    const [peopleDocuments, setPeopleDocuments] = useState([])

    const [companyReg, setCompanyReg] = useState('');
    const [IDname, setIDname] = useState('');
    const [address, setAddressName] = useState('');
    const [contract, setContractName] = useState('');


    const [files, setFiles] = useState([]);

    const [item, setItem] = useState([]);
    const [inc_date, setIncDate] = useState();
    const [editDocs, setEditDocs] = useState(false)

    const [blacklist, setBlacklist] = useState([])
    const [representatives, setRepresentatives] = useState([])
    
    const user_id = Cookies.get('token_id');
    const admin = Cookies.get('token_admin');
    const [isCreator, setIsCreator] = useState(false)

    const {reference} = useParams();

    const test_link = "http://localhost:3000/"
    const production_link = "https://apple-tree-server.vercel.app/"

    const navigate = useNavigate();

    const getBlacklist = async () => {
        const response = await axios.get(production_link + 'blacklist/');
        const blacklistData = response.data;
    
        const item = blacklistData.find(item => item.reference_number === reference);
    
        if (item) {
            const incident_date = item.incident_date;
            const inc_date = moment(incident_date).format('YYYY-MM-DD');
            setItem(item);
            setIncDate(inc_date);
        }
    
        return item;
    };
    
    const getRepresentatives = async () => {
        const response = await axios.get(production_link + 'representatives/');
        const reps = response.data;
    
        setRepresentatives(reps);
    
        return reps;
    };
    

    // const getRepresentatives = async () => {
    //     const response = await axios.get(production_link + 'representatives/');
    //     const reps = response.data;
    
    //     setRepresentatives(reps);
    
    //     // Find the correct representative based on the company_id
    //     const rep = reps.find(rep => rep.company_id === item.company_id);
    //     console.log(rep)
    
    //     if (rep) {
    //         setItem(prev => ({ ...prev, person_id: rep.person_id }));
    //     }
    // }
    
    useEffect(() => {
        const fetchData = async () => {
            const [blacklistItem, reps] = await Promise.all([getBlacklist(), getRepresentatives()]);
            if (blacklistItem) {
                setIsCreator(blacklistItem.user_id == user_id)
                const rep = reps.find(rep => rep.company_id === blacklistItem.company_id);
    
                if (rep) {
                    setItem(prev => ({ ...prev, person_id: rep.person_id }));
                }
                
                const newFiles = await getDocuments({...blacklistItem,person_id: rep.person_id});
                setFiles(newFiles)
            }
        };
    
        fetchData();
        console.log(item)

    }, []);
    
    

    // const getBlacklist = async () => {
    //     const blackliststuff = await axios.get(production_link + 'blacklist/')
    //     .then(async response => {
            
    //         setBlacklist(response.data)
    //         for (let index = 0; index < response.data.length; index++) {
    //             const item = response.data[index];
    //              if (item.reference_number === reference) {
    //                     const incident_date = item.incident_date;
    //                     const inc_date = moment(incident_date).format('YYYY-MM-DD')
    //                     setItem(item)
    //                     setIncDate(inc_date)

    //                     return item

    //             }
    //         }
    //     })

    //     return blackliststuff
    // }


    // const getRepresentatives = async () => {
    //         await axios.get(production_link + 'representatives/')
    //         .then(response => {
    //             setRepresentatives(response.data)
    //             console.log(response.data)
    //             response.data.map((rep) => {
    //                 setItem(prev => ({...prev, person_id: rep.person_id}))
    //             })
    //         })
    
    //     }

    const formatter = new Intl.NumberFormat('en-ZA', {
  style: 'currency',
  currency: 'ZAR',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
//   maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});



const getDocuments = async (item) => {
    const fetchAndStoreURL = async (doc, type) => {
        const url = await downloadFile(doc.name);
        if (type === 'ID') {
            setIDdownload(url);
            setIDname(doc.name);
        } 
        if (type === 'company') {
            setCompanyRegdownload(url);
            setCompanyReg(doc.name);
        }
        if (type === 'address') {
            setAddressdownload(url);
            setAddressName(doc.name);
        }
        if (type === 'contract') {
            setContractdownload(url);
            setContractName(doc.name);
        }
    }

    // Initialize empty arrays to accumulate documents
    const additionalDocs = [];
    const companyDocs = [];
    const incidentDocs = [];
    const peopleDocs = [];

    // Fetch and process additional documents
    const additionalResponse = await axios.get(production_link + 'documents/additional/');
    additionalResponse.data.forEach((doc) => {
        if (doc.blacklist_id == item.blacklist_id && doc.name != null && doc.archived == 'false') {
            additionalDocs.push(doc);
        }
    });

    // Fetch and process company documents
    const companyResponse = await axios.get(production_link + 'documents/company/');
    await Promise.all(companyResponse.data.map(async (doc) => {
        if (doc.company_id == item.company_id && doc.name != null && doc.archived == 'false') {
            companyDocs.push(doc);
            await fetchAndStoreURL(doc, 'company');
        }
    }));

    // Fetch and process incident documents
    const incidentResponse = await axios.get(production_link + 'documents/incident/');
    await Promise.all(incidentResponse.data.map(async (doc) => {
        if (doc.incident_id == item.incident_id && doc.name != null && doc.archived == 'false') {
            incidentDocs.push(doc);
            await fetchAndStoreURL(doc, 'contract');
        }
    }));

    // Fetch and process people documents
    const peopleResponse = await axios.get(production_link + 'documents/people/');
    await Promise.all(peopleResponse.data.map(async (doc) => {
        if (doc.person_id == item.person_id && doc.name != null && doc.archived == 'false') {
            peopleDocs.push(doc);
            if (doc.type === "ID document") {
                await fetchAndStoreURL(doc, 'ID');
            } else if (doc.type === "Proof of address") {
                await fetchAndStoreURL(doc, 'address');
            }
        }
    }));

    // Set state only once after processing all documents
    setAdditionalDocuments(additionalDocs);
    setCompanyDocuments(companyDocs);
    setIncidentDocuments(incidentDocs);
    setPeopleDocuments(peopleDocs);

    setDone(true);
    return (additionalDocs.concat(companyDocs, incidentDocs, peopleDocs))
};

const downloadFile = async (filename) => {
    const downloadRef = ref(storage, `files/${filename}`);
    const url = await getDownloadURL(downloadRef);
    return url;
}


    // const displayDocuments = async (item) => {
    //     console.log(item)
    //     if (incidentDocuments.length > 0) {
    //         incidentDocuments.map(async (doc) => {
    //             if (doc.incident_id === item.incident_id) {

    //                 await downloadFile(doc.name, "contract")
    //             }
    //         })
    //     }
        
    //     if (companyDocuments.length > 0) {
    //         companyDocuments.map(async (doc) => {
    //             if (doc.company_id === item.company_id) {
    //                 // setFiles(prevState => [...prevState, doc])
    //                 await downloadFile(doc.name, "company")
    //             }
    //         })
    //     }

    //     if (peopleDocuments.length > 0) {

    //         peopleDocuments.map(async (doc) => {
    //             if (doc.person_id === item.person_id && doc.type === "ID document") {
    //                 await downloadFile(doc.name, "ID")
    //             } else if (doc.id === item.person_id && doc.type === "Proof of address") {
    //                 await downloadFile(doc.name, "address")
    //             }
    //         })
    //     }

    //     setTimeout(() => {
    //         setDone(true)
    //     }, 2000)
        
    // }

    const deleteBlacklist = async (blacklist_id) => {
        await axios.post(production_link + 'archive', {
            blacklist_id
        })
        .then((res) => {
            alert('Blacklist deleted successfully');
            
            navigate('/')
            window.location.reload(false)
        })
        .catch((err) => alert(err))
    }

    if (!done) {
        return (
            <div>


                   
                  <div style={{height:"50vh"}} className="d-flex justify-content-center align-items-center ">
                  
                              <CircleLoader size={200} color="#cdc59a"/>
              </div>
              </div>
        )
    }

    const deleteDoc = async (filename, type) => {
        const user_id = Cookies.get('token_id');
        const user_name = Cookies.get('token_first_name')
        console.log("File: " + filename)
        console.log("Type: " + type)

        await axios.post(production_link + "delete/document", {
            user_id,
            user_name,
            type,
            filename
        })
        .then((res) => {
            console.log(res)
            alert("Document deleted successfully")
            window.location.reload(false)
        })
        .catch((err) => {
            console.log(err)
            alert("Error deleting document")
        })
    }
    return ( 
        <div>
            {   
                        <div class="card text-center">
                            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog">
                            <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="exampleModalLabel">Delete</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                Delete blacklist? 
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-success" onClick={() => {
                                    deleteBlacklist(item.blacklist_id);
                                }}>Yes</button>
                            </div>
                            </div>
                        </div>
                        </div>
                            {!blacklistEditMode &&
                            <div className="d-flex justify-content-between card-header ">
                                <a className="text-info ms-3" href="#documents" onClick={() => {
                                    setEditDocs(true)
                                }}>
                                    {files.length} documents
                                </a>
                                <h4 class="display-6">
                                    {item.company_name}
                                </h4>
                                <div>
                                    {
                                        (isCreator || admin == 'yes') &&
                                    <button data-bs-toggle="modal" data-bs-target="#exampleModal" className="btn text-danger me-3">X Delete</button>

                                    }
                                </div>
                            </div>
                           
                            }
                            
                            <div class="card-body  d-flex flex-column jusify-content-center align-items-center">

                            {
                                !blacklistEditMode &&
                                <div className="card p-4 w-75">
                                    <h5 class="card-title">{item.category}</h5>
                                    <p class="card-text">Incident date: <br /><span className="text-secondary">{inc_date}</span></p>
                                    <p class="card-text">Information: <br /><span className="text-secondary">{item.information}</span></p>
                                    <p class="card-text">Amount applied for: <br /><span className="text-secondary">{(item.amount_applied == "" || item.amount_applied == null) ? "R0" :formatter.format(Number(item.amount_applied))}</span></p>
                                    <p class="card-text">Amount lost: <br /><span className="text-secondary">{(item.amount_lost == "" || item.amount_lost == null) ? "R0" : formatter.format(Number(item.amount_lost))}</span></p>
                                    <p class="card-text">Case number: <br /><span className="text-secondary mt-0">{item.case_number}</span></p>
                                    <hr/>
                                    {
                                            incidentDocuments.length > 0 &&
                                            <div>
                                                <h5 className="display-5 mb-3">Documents</h5>

                                                <p class="card-text" >Contract/Agreement: <br /></p><a className="text-secondary" href={Contractdownload} target="blank_">{contract}</a>

                                            </div>

                                        }
                                </div>
                            }
                                
                                
                                
                                {/* <div className="d-flex flex-column align-items-center"> */}
                                {
                                    !blacklistEditMode &&
                                    <button class="btn btn-outline-secondary my-2" onClick={(e) => {
                                    e.preventDefault();
                                    if (showCompany) {
                                        setShowCompany(false)
                                    } else {
                                        setShowCompany(true)
                                    }
                                }}>Company Details</button>
                                }
                                
                                {
                                    showCompany && !blacklistEditMode &&
                                    <div className="card p-4 w-75">
                                        <h5 className="display-5 mb-3">{item.company_name}</h5>
                                        <p class="card-text">Company Registration: <br /><span className="text-secondary">{item.registration_number}</span></p>
                                        <p class="card-text">Company Type: <br /><span className="text-secondary">{item.company_type}</span></p>
                                        <p class="card-text">VAT number: <br /><span className="text-secondary">{item.tax_number}</span></p>
                                        <p class="card-text">Company address: <br /><span className="text-secondary">{item.address}</span></p>
                                        <p class="card-text">Company phone: <br /><span className="text-secondary">{item.company_phone}</span></p>
                                        <p class="card-text">Company email: <br /><span className="text-secondary">{item.company_email}</span></p>
                                        <hr/>
                                        {
                                            companyDocuments.length > 0 &&
                                            <div>
                                                <h5 className="display-5 mb-3">Documents</h5>

                                                <p class="card-text" >Company registration document: <br /></p><a className="text-secondary" href={Companydownload} target="blank_">{companyReg}</a>

                                            </div>

                                        }

                                    </div> 
                                 
                                }

                                {
                                    blacklistEditMode &&
                                    <DetailEdit reference = {reference}/>    


                                }
                                {
                                    (isCreator || admin == 'yes') &&
                                    <button className="btn btn-outline-primary w-75 my-2" onClick={(e) => {
                                        blacklistEditMode ? setBlacklistEditMode(false) : setBlacklistEditMode(true)
                                       }}>Edit Incident/Company</button>
                                }
                                

                                
                                <button class="btn btn-outline-secondary my-4"  onClick={(e) => {
                                    e.preventDefault();
                                    if (showRep) {
                                        setShowRep(false)
                                    } else {
                                        setShowRep(true)
                                    }
                                }}>Representative Details</button>
                                
                                {
                                    showRep && 
                                    <div className="card p-4 w-75">
                                       {
                                        representatives.map((rep) => {
                                            if (item.company_id === rep.company_id) {
                                                return !repEditMode ?  (
                                                    
                                                    <div>
                                                        <h5 className="display-5 mb-3 my-3">{rep.first_name} {rep.last_name}</h5>
                                                        <p class="card-text">Title: <br /><span className="text-secondary">{rep.title}</span></p>
                                                        <p class="card-text">ID type: <br /><span className="text-secondary">{rep.id_type}</span></p>
                                                        <p class="card-text">ID number: <br /><span className="text-secondary">{rep.id_number}</span></p>
                                                        <p class="card-text">Date of birth: <br /><span className="text-secondary">{rep.date_of_birth}</span></p>
                                                        <p class="card-text">Gender: <br /><span className="text-secondary">{rep.gender}</span></p>
                                                        <p class="card-text">Marital: <br /><span className="text-secondary">{rep.marital}</span></p>
                                                        <p class="card-text">Phone: <br /><span className="text-secondary">{rep.phone}</span></p>
                                                        <p class="card-text">Email: <br /><span className="text-secondary">{rep.email}</span></p>
                                                        <hr></hr>
                                                    </div>
                                                ) : <DetailRepEdit person_id ={rep.id} />
                                            }
                                        })
                                       }

                                       {
                                        (item.user_id == user_id || admin == 'yes')  &&
                                        <button className="btn btn-outline-primary " onClick={(e) => {
                                        repEditMode ? setRepEditMode(false) : setRepEditMode(true)
                                       }}>Edit representative</button>
                                       }
                                       

                                        {
                                            peopleDocuments.length > 0 &&
                                            <div>
                                                <h5 className="display-5 mb-3 my-3">Documents</h5>
                                                
                                                <p class="card-text" >ID document: <br /></p><a className="text-secondary" href={IDdownload} target="blank_">{IDname}</a>

                                            </div>

                                        }

{
                                            peopleDocuments.length > 0 &&
                                            <div>
                                                <p class="card-text" >Proof of address: <br /></p><a className="text-secondary" href={Addressdownload} target="blank_">{address}</a>

                                            </div>

                                        }

                                    </div>
                                }
                                
                                
                                {
                                    showDocs && additionalDocuments.length > 0 && item != null &&
                                    <>
                                        <button class="btn btn-outline-secondary my-2" onClick={(e) => {
                                            e.preventDefault();
                                            if (showDocs) {
                                                setShowDocs(false)
                                            } else {
                                                setShowDocs(true)
                                            }
                                        }}>Additional Documents</button>
                                        <AddDocuments additionalDocuments={additionalDocuments} item={item}/>
                                    </>
                                }


                                {/* </div> */}
                                <section id="documents">
                                    
                                        <button className="btn btn-outline-secondary" onClick={() => {
                                                editDocs ? setEditDocs(false) : setEditDocs(true)
                                            }}>
                                                Edit Documents
                                            </button>
                                    
                                    
                                </section>
                                
                                
                            </div>
                            {
                                editDocs &&
                                <div className="d-flex justify-content-center align-items-center flex-column">
                                <div className="w-75">
                                    <AdditionalDocs company_id={item.company_id} incident_id={item.incident_id} person_id={item.person_id} blacklist_id={item.blacklist_id}  details={true}/>

                                </div>

                                <div className="border p-4 rounded w-100 mt-2 d-flex justify-content-center align-items-center">
                                        <div className="d-flex flex-wrap w-75">
                                            {
                                            files.map((file) => {
                        
                                                return (
                                                    <div className="btn-group m-1 ">
                                                        <div style={{
                                                            maxWidth: " 200px",
                                                            maxHeight: "50px",
                                                            overflow:"scroll",
                                                            fontSize:"0.5rem"
                                                        }} className="btn btn-outline-info">
                                                            {file.name}
                                                        </div>
                                                        {
                                                            (isCreator || admin == 'yes') &&
                                                            <button className="btn btn-sm btn-primary " onClick={(e) => {
                                                                e.preventDefault()
                                                                deleteDoc(file.name, file.type)
                                                            }}>Delete</button>
                                                        }
                                                        
                                                    </div>
                                                
                                            )})
                                        }


                                        </div>
                                        
                                </div>
                                </div>
                            }
                            

                            <div class="card-footer text-muted">
                                
                            </div>
                        </div>
                    
            }

           

        </div>
        
    );
}
 
export default Details;